import React, { FC, useContext } from 'react';

import { Button, Modal } from '@smartshell/ui-kit';

import { LocalizationContext } from 'localization';

import s from './NotPermissionModal.module.scss';

export const NotPermissionModal: FC<{ onClose: () => void }> = ({
  onClose,
}) => {
  const { t } = useContext(LocalizationContext);
  return (
    <Modal onClose={onClose} className={s.modal}>
      <div className={s.content}>
        <span className={s.text}>{t('permission.error')}</span>
        <Button onClick={onClose} fullWidth>
          {t('ok')}
        </Button>
      </div>
    </Modal>
  );
};
